<template>
    <div>
        <b-row class="m-b-15">
            <b-col>
                <div class="card border-0 bg-dark text-white text-truncate mb-3 h-100">
                    <div class="card-body">
                        <div class="mb-3 text-grey">
                            <b class="mb-3">COMPLETED</b> 
                            <span class="ml-2"><i class="fa fa-info-circle" title="Completed steps, stages and storyboards" v-b-popover.hover="'This is a compilation of script stats'"></i></span>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-black f-s-8 mr-2"></i>
                                Steps
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ countCompletedSteps }}</div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-gray f-s-8 mr-2"></i>
                                Stages
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ countCompletedStages }}</div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-white f-s-8 mr-2"></i>
                                Storyboards
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="width-50 text-right pl-2 f-w-600">{{ countCompletedStoryboards }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col>
                <div class="card border-0 bg-dark text-white text-truncate mb-3 h-100">
                    <div class="card-body">
                        <div class="mb-3 text-grey">
                            <b class="mb-3">COMPLETED 4S</b> 
                            <span class="ml-2"><i class="fa fa-info-circle" title="Script stats" v-b-popover.hover="'This is a compilation of script stats'"></i></span>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-indigo f-s-8 mr-2"></i>
                                Space
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div v-if="stepsTotal" class="width-50 text-right pl-2 f-w-600">
                                    {{ (spaceCompleted / stepsTotal * 100).toFixed(2) }} %
                                </div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-blue f-s-8 mr-2"></i>
                                Stuff
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div v-if="stepsTotal" class="width-50 text-right pl-2 f-w-600">
                                    {{ (stuffCompleted / stepsTotal * 100).toFixed(2) }} %
                                </div>
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-green f-s-8 mr-2"></i>
                                Staff
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div v-if="stepsTotal" class="width-50 text-right pl-2 f-w-600">
                                    {{ (staffCompleted / stepsTotal * 100).toFixed(2) }} %
                                </div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-circle text-red f-s-8 mr-2"></i>
                                Service
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div v-if="stepsTotal" class="width-50 text-right pl-2 f-w-600">
                                    {{ (serviceCompleted / stepsTotal * 100).toFixed(2) }} %
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col>
                <b-card bg-variant="dark" text-variant="light" title="Tooltip" class=" h-100">
                    <b-card-text>
                        Seven steps to complete in Event Script:
                        <ol>
                            <li>Pick your step to plan</li>
                            <li>Review target outcome for this step (or if not defined, do it now.)</li>
                            <li>Add Space item(s) required with relevant information</li>
                            <li>Add Stuff items required with relevant information</li>
                            <li>Add Staff itemsrequired with relevant information</li>
                            <li>Add Support Service items required with relevant information</li>
                            <li>Take a look at a summary and confirm your plan</li>
                        </ol>
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <!-- begin panel -->
                <panel no-button="true" title="Select steps to plan">

                    <search-table 
                        :storyboards="storyboards" 
                        :stages="stages" 
                        :steps="steps" 
                        :activeEvent="activeEvent" 
                        :selectedSteps="selectedSteps" 
                        :scriptItems="scriptItems" 
                    />
                    
                </panel>
                <!-- end panel -->
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SearchTable from '../script/SearchTable.vue'

export default {
    name: 'ScriptIndex',
    components: {
        SearchTable
    },
    props: ['storyboards', 'stages', 'steps', 'activeEvent', 'item', 'categories', 'scriptItems', 'selectedSteps'],
    data() {
        return {
            selected: [],
            spaceCompleted: 0,
            stuffCompleted: 0,
            staffCompleted: 0,
            serviceCompleted: 0,
            stepsTotal: 0,
            completedStepsCount: 0,
            completedStagesCount: 0,
            completedStoryboardsCount: 0
        }
    },
    computed: {
        countCompletedSteps() {
            if (!this.completedStepsCount) {
                var stages = this.$parent.filterEventStages(this.activeEvent.id);
                stages.forEach(stage => {
                    var steps = stage.steps;
                    steps.forEach(step => {
                        if (step.space && step.stuff && step.staff && step.service) {
                            this.completedStepsCount += 1;
                        }
                    });
                });
            }
            return this.completedStepsCount;
        },
        countCompletedStages() {
            if (!this.completedStagesCount) {
                var stages = this.$parent.filterEventStages(this.activeEvent.id);
                stages.forEach(stage => {
                    var stageComplete = true;
                    stage.steps.forEach(step => {
                        if (!step.space || !step.stuff || !step.staff || !step.service) {
                            stageComplete = false;
                        }
                    });
                    if (stageComplete) {
                        this.completedStagesCount += 1;
                    }
                });
            }
            return this.completedStagesCount;
        },
        countCompletedStoryboards() {
            if (!this.completedStoryboardsCount) {
                var storyboards = this.$parent.filterEventStoryboards(this.activeEvent.id);
                var stages = this.$parent.filterEventStages(this.activeEvent.id);
                storyboards.forEach(storyboard => {
                    var storyboardComplete = true;
                    if (storyboard.stages.length) {
                        stages.forEach(stage => {
                            storyboard.stages.forEach(sbStage => {
                                if (sbStage.id == stage.id) {
                                    var steps = stage.steps;
                                    if (steps.length) {
                                        steps.forEach(step => {
                                            if (!step.space || !step.stuff || !step.staff || !step.service) {
                                                storyboardComplete = false;
                                            }
                                        });
                                    } else {
                                        storyboardComplete = false;
                                    }
                                }
                            });
                        });
                    } else {
                        storyboardComplete = false;
                    }
                    if (storyboardComplete) {
                        this.completedStoryboardsCount += 1;
                    }
                });
            }
            return this.completedStoryboardsCount;
        },
    },
    methods: {
        selectSteps(selected) {
            this.$parent.filterSelectedSteps(selected);
        },
        countCompletedTypes() {
            var stages = this.$parent.filterEventStages(this.activeEvent.id);
            stages.forEach(stage => {
                var steps = stage.steps;
                steps.forEach(step => {
                    this.stepsTotal += 1;
                    if (step.space) {
                        this.spaceCompleted += 1;
                    }
                    if (step.stuff) {
                        this.stuffCompleted += 1;
                    }
                    if (step.staff) {
                        this.staffCompleted += 1;
                    }
                    if (step.service) {
                        this.serviceCompleted += 1;
                    }
                });
            });
        },
    },
    mounted() {
        this.countCompletedTypes();
    }
}
</script>